/** Reglas de la barra de filtros (tabla y tablero), aparte del componente para compartirlas sin romper el refresco. */

/** Valor del select Asesor que representa «sin asesor» (en la URL viaja como `unassigned=true`). */
export const UNASSIGNED_OPTION = 'SIN_ASIGNAR';

/**
 * Cambia un filtro en la URL aplicando las reglas que atan unos filtros a otros (tabla y tablero usan la misma):
 * - al cambiar de empresa se limpian proyecto, asesor, etiqueta y campos personalizados (son de la otra empresa);
 * - «Días vencidos» implica seguimiento VENCIDO (7.19); otro seguimiento lo limpia;
 * - la banda de vencidos que traen los enlaces de Equipo (`overdueBand`) se limpia al tocar Seguimiento o Días vencidos;
 * - «Sin asesor» del select Asesor es `unassigned=true` (sin `advisorId`).
 */
export function applyLeadFilter(params: URLSearchParams, key: string, value: string) {
  const next = new URLSearchParams(params);
  if (key === 'advisorId') {
    next.delete('advisorId');
    next.delete('unassigned');
    if (value === UNASSIGNED_OPTION) next.set('unassigned', 'true');
    else if (value) next.set('advisorId', value);
    return next;
  }
  if (value) next.set(key, value);
  else next.delete(key);
  if (key === 'companyId') {
    next.delete('projectId');
    next.delete('advisorId');
    next.delete('unassigned');
    next.delete('tagIds');
    for (const k of [...next.keys()]) if (k.startsWith('cf_')) next.delete(k);
  }
  if (key === 'overdueDays' && value) next.set('followupState', 'VENCIDO');
  if (key === 'followupState' && value !== 'VENCIDO') next.delete('overdueDays');
  if (key === 'overdueDays' || key === 'followupState') next.delete('overdueBand');
  return next;
}
